import {CompetitionTransfersPageRouteMetaDataModel} from "./competition-transfers-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionTransfersPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.transfers,
      path: 'transfers',
      componentImport: () => import("../components/competition-transfers-page" /* webpackChunkName: "competition-transfers-page" */),
      metadataType: CompetitionTransfersPageRouteMetaDataModel
    });
  }
}